import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Admin from "./view/admin/Admin";
import Login from "./view/login/Login";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/admin/*" element={ <Admin /> } />
                <Route path="/" element={ <Login /> } />
                <Route path="*" element={ <Login /> } />
            </Routes>
        </BrowserRouter>
    );
}